// extracted by mini-css-extract-plugin
export default {"activateAccount":"ActivateAccount_activateAccount__yfQw+"};